import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "artists", label: "Artists" },
  { id: "studios", label: "Studios" },
  { id: "portfolio", label: "Portfolio" },
  { id: "guest", label: "About" },
  { id: "booking", label: "Booking" },
  { id: "location", label: "Location" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-white/85 backdrop-blur-md border-b border-[#E5E5E5]" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className={`text-xs md:text-base font-medium tracking-[0.22em] md:tracking-[0.28em] uppercase transition-colors ${
            scrolled ? "text-[#0A0A0A]" : "text-white mix-blend-difference"
          }`}
        >
          <span className="hidden sm:inline">JAY-INK&nbsp;ACADEMY</span>
          <span className="sm:hidden">JAY-INK</span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              className={`text-xs tracking-[0.2em] uppercase transition-colors hover:opacity-60 ${
                scrolled ? "text-[#0A0A0A]" : "text-white mix-blend-difference"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#booking"
            data-testid="nav-book-cta"
            className={`text-xs tracking-[0.2em] uppercase px-5 py-2.5 border transition-all ${
              scrolled
                ? "border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white"
                : "border-white text-white hover:bg-white hover:text-[#0A0A0A]"
            }`}
          >
            Book
          </a>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
          className={`md:hidden p-2 ${scrolled ? "text-[#0A0A0A]" : "text-white mix-blend-difference"}`}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden bg-white border-t border-[#E5E5E5]"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${l.id}`}
                className="text-sm tracking-[0.22em] uppercase text-[#0A0A0A]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#booking"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-book"
              className="mt-2 inline-block self-start text-xs tracking-[0.22em] uppercase px-5 py-3 border border-[#0A0A0A] text-[#0A0A0A]"
            >
              Book a consultation
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
